export class NetworkError<R = unknown> extends Error {
  constructor(public data?: R) {
    super();
  }
}
